/*
 Copyright (c) 2026 Wind River Systems, Inc.

 The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
 */

import { Component, OnInit } from '@angular/core';
import { ConfigService } from '@windriver/authentication';
import { ConfigState } from '../../../../models/config-state';
import { ProductsService } from '../../../../services/products/products.service';

@Component({
  selector: 'wsn-tracking-banner-impersonation',
  templateUrl: './tracking-impersonation-banner.component.html',
  styleUrls: ['./tracking-impersonation-banner.component.scss']
})
export class TrackingImpersonationBannerComponent implements OnInit {
  isImpersonating: boolean;

  constructor(private configService: ConfigService, private productService: ProductsService) {}

  ngOnInit(): void {
    this.configService.configState.subscribe((config: ConfigState) => {
      if (config.showImpersonationBanner) {
        this.productService.impersonationEmitter.subscribe((impersonating) => {
          this.isImpersonating = impersonating;
        });
      }
    });
  }

  get impersonatedUser() {
    return this.productService.impersonatedUsername;
  }
}
